import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
// import MealsStructure from "../../components/diet/meal/MealsStructure";
// import BackAddBtns from "../../components/Open-pages/target-matrics/common/BackAddBtns";
import { selectAuth } from "../../components/auth/auth.selector";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import AgentMapForm from "../../components/automation/agent-map/AgentMapForm";
import { fetchAllAgentsData } from "../../redux/reducers/apiSlice";
import { formattedLongDate } from "../../components/common-data/Converts";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { toast } from "react-toastify";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { deleteMapping } from "../../data/ApiEndpoints";
import CommonStructured from "../../components/common-components/CommonStructured";
import { BinIcon2, EditIcon2 } from "../../images/icons/icons";

const AgentMapping = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;
  const { allAgentsLoading, allAgents } = useSelector((state) => state.api);

  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [isPage, setIsPage] = useState(0);
  const iniFilters = {
    page: isPage + 1,
    page_size: 10,
    is_mapped: 1,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    allData: [],
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickModal = () => {
    setModValues((prevs) => ({ ...prevs, isModOpen: true, cardType: "add" }));
  };

  function getAgents(filter) {
    dispatch(
      fetchAllAgentsData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: deleteMapping,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(
              response?.message || "mapping is deleted successfully!"
            );
            getAgents(filters);
          } else {
            toast.error(response?.message || "Can not delete mapping!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete mapping");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete this mapping!`
      );
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    getAgents(filters);
  }, [filters]);

  useEffect(() => {
    if (allAgents?.status && allAgents?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: allAgents.data || [],
        pagination: allAgents?.pagination || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [allAgents]);

  const tbColumns = [
    {
      dataField: "name",
      text: "Mapped Agent",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "wtf_agent_name",
      text: "WTF Agent",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.wtf_agent_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.wtf_agent_mobile || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "mopr_agent_name",
      text: "IVR Agent",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.mopr_agent_name || "NA"} <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mopr_agent_mobile || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "panel_type",
      text: "panel type",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.panel_type === "panel_1"
              ? "Main"
              : row?.panel_type === "panel_2"
              ? "IVR"
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "mopr_agent_id",
      text: "IVR agent ID",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            <small>{row?.mopr_agent_id || "-"}</small>
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className={`actionBtn icon edit`}
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardType: "edit",
                rowData: row,
              }));
            }}
          >
            <EditIcon2 />
          </button>

          <button
            type="button"
            className={`actionBtn icon delete`}
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            <BinIcon2 />
          </button>
        </div>
      ),
    },
  ];

  return (
    <HelmetWrapper title="WTF: Agent Mapping">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={closeModal}
          contentLabel="Agent Map Modal"
          ariaHideApp={false}
        >
          <div className="createNewCTOModalContainer mod-width-70p mod-height-95vh">
            <ModalHeadAndClose title="Map Agent" onClose={closeModal} />

            <AgentMapForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={() => getAgents(filters)}
              isEdit={modValues.cardType === "edit" ? true : false}
              rowData={modValues.cardType === "edit" ? modValues.rowData : {}}
            />
          </div>
        </Modal>

        {/* <Row>
          <Col>
            <MealsStructure text={"Agent Mapping"} />
          </Col>
        </Row> */}

        <Row>
          <Col>
            <CommonStructured
              pageHeading="Agent Mapping"
              createBtnTxt="Map Agents"
              onClickCreateBtn={onClickModal}
              isReload={() => getAgents(filters)}
            />
            {/* <BackAddBtns
              addBtnTxt={"Map Agents"}
              onClickAdd={onClickModal}
              onClickReload={() => getAgents(filters)}
              isAddBtn={true}
            /> */}
          </Col>
        </Row>

        <Row>
          <Col>
            {allAgentsLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <div className="overflowAuto separatedTable mt15">
                <PaymentLinkTable
                  tableData={tbDatas.allData}
                  tableColumns={tbColumns}
                  tablePagination={tbDatas.pagination}
                  isPage={isPage}
                  setIsPage={setIsPage}
                />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default AgentMapping;
